/**
 * Has a session already started, by the device's clock? Started sessions show
 * greyed out with no Reschedule/Cancel (the API refuses them too).
 */
export function hasStarted(a: { date: string; start_time: string }, now = new Date()): boolean {
  const [y, m, d] = a.date.split('-').map(Number);
  const [h, min] = a.start_time.split(':').map(Number);
  return new Date(y, m - 1, d, h, min) <= now;
}
